module.exports = __webpack_public_path__ + "d4f536a3dd8a778656e40a1614b6bcbd.pdf";